import { Injectable } from '@angular/core';
import { observable } from 'rxjs';
import { ConfigService } from '../../common/services/config.service';
import { HttpInterceptor } from '../../common/services/httpInterceptor.service';
import { SessionHandlerService } from '../../common/services/sessionHandler.service';
import { CommonConstants } from '../../common/utilities/commonConstants';
@Injectable({
    providedIn: 'root'
})
export class ProductReviewService {

    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandler: SessionHandlerService
    ) { }

    public PostPreviousPolicyCallService(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.postCallPreviousPolicy;
        url = url.replace('{applicationId}', this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId));
        return this._httpInterceptor.Post(url, data);
    }
    public postSendMobileOTP(data) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.resumeGetOtp;
        return this._httpInterceptor.Post(url, data);
    }
    public postValidateOTP(data) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.ValidatePostOtp;
        return this._httpInterceptor.Post(url, data);
    }
    public postSendMobileOTPForReviewDetails(payload) {
        const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        const quoteId = (this._sessionHandler.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId));
        let url = ConfigService.getInstance().getConfigObject().APIURL.postOTPForReviewDetail;
        url = url.replace('{quoteId}', quoteId);
        url = url.replace('{applicationId}', applicationId);

        return this._httpInterceptor.Post(url, payload);
    }
    public postValidateOTPForReviewDetails(data) {
        const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        const quoteId = (this._sessionHandler.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId));
        let url = ConfigService.getInstance().getConfigObject().APIURL.ValidatePostOtpForReviewDetails;
        url = url.replace('{quoteId}', quoteId);
        url = url.replace('{applicationId}', applicationId);

        return this._httpInterceptor.Put(url, data);
    }
    public postResendSendMobileOTPForReviewDetails(payload,consentKey) {
        const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        const quoteId = (this._sessionHandler.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId));
        let url = ConfigService.getInstance().getConfigObject().APIURL.resendOtpForReviewDetail;
        url = url.replace('{quoteKey}', quoteId);
        url = url.replace('{applicationId}', applicationId);
        url = url.replace('{consentkey}', consentKey);
        return this._httpInterceptor.Put(url, payload);

    }
    public postSendQuotationLinkService(payload) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.sendQuotatioLinkService;
        return this._httpInterceptor.Post(url, payload);
    }
}
